import React from "react";
import { useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import { List } from "semantic-ui-react";
import { ProjectExportButton, ProjectDeleteButton } from "../buttons";
import ProjectListItem from "./ProjectListItem";
import RecordingBulkUpdateButton from "../buttons/RecordingBulkUpdateButton";

const ProjectList = ({ history }) => {
  const projects = useSelector((state) => state.projects);
  const reviewer = useSelector((state) => state.mode.reviewer);
  return (
    <List divided animated verticalAlign="middle" selection relaxed="very">
      {projects.ids.map((id) => {
        const project = projects.hash[id];
        return (
          <List.Item key={id}>
            <List.Content floated="right">
              {reviewer && <RecordingBulkUpdateButton projectId={id} />}
              <ProjectExportButton projectId={id} />
              <ProjectDeleteButton projectId={id} />
            </List.Content>
            <List.Content
              onClick={() => {
                if (project.state === "ok") history.push(project.url);
              }}
            >
              <ProjectListItem project={project} />
            </List.Content>
          </List.Item>
        );
      })}
    </List>
  );
};

export default withRouter(ProjectList);
